import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import "./MoreUpdate1.css";

import BlogImg4 from "../../assets/blog/blogImg4.png";
import BlogImg5 from "../../assets/blog/blogImg5.png";
import BlogImg6 from "../../assets/blog/blogImg6.png";

const moreUpdatesData = [
  {
    id: 4,
    title: "Diversify and Prosper with Portfolio Management",
    image: BlogImg6,
  },
  {
    id: 5,
    title: "Stay Informed with Real-Time Updates",
    image: BlogImg5,
  },
  {
    id: 6,
    title: "Optimizing Strategies for Financial Growth",
    image: BlogImg4,
  },
];

const MoreUpdate1 = () => {
  return (
    <section className="more-update-section">
      <div className="more-update-container">
        <h2 className="more-update-title">More Update</h2>

        <div className="more-update-grid">
          {moreUpdatesData.map((blog) => {
            // Generates URL path from title (e.g., /blog/stay-informed-with-real-time-updates)
            const blogPath = `/blog/${blog.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;

            return (
              <Link
                to={blogPath}
                className="mu-card"
                key={blog.id}
                onClick={() => window.scrollTo(0, 0)}
              >
                <div className="mu-img-wrapper">
                  <img src={blog.image} alt={blog.title} className="mu-img" />
                  <div className="mu-gradient-overlay"></div>
                </div>

                <div className="mu-content">
                  <h3 className="mu-card-title">{blog.title}</h3>
                  <ArrowUpRight className="mu-card-icon" size={20} />
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default MoreUpdate1;
